import {FeaturedVideo, PeopleOutline} from "@mui/icons-material";
import './IconStyles.scss'

export const SupplierSegmentationIcon = () => <>
    <div className="composite-icon-wrapper small supplier-segmentation-icon">
        <PeopleOutline/>
        <FeaturedVideo className="second-icon"/>
    </div>
</>
